import React, { FunctionComponent, useState } from "react";
import styles from "./AuthorizationViewModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import Dropdown from "../../DropDown/Dropdown";
import { useEffect } from "react";
import { updateUserAuthorization } from "../../../Services/organizations";
import { showSnackbarAction } from "../../../Redux/actions";
import axios from "axios";
import { url } from "../../../Values/constants";
import axiosHandler from "../../../Services/axiosHandler";

type props = {
  open: boolean;
  close: () => void;
  organizationId: any;
  organizationUsers: any[];
  user: any;
  authToken: any;
};
const AuthorizationViewModal: FunctionComponent<props> = ({
  open,
  close,
  organizationId,
  organizationUsers,
  user,
  authToken,
}) => {
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [userSelected, setUserSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [userProfileSelected, setUserProfileSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [selectOptionSelected, setSelectOptionSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [optionsSelected, setOptionsSelected] = useState<any[]>([]);
  const [leadManagerList, setLeadManagerList] = useState<any[]>([]);
  const [teamLeaderList, setTeamLeaderList] = useState<any[]>([]);
  const [salesList, setSalesList] = useState<any[]>([]);
  const [leadManagerUid, setLeadManagerUids] = useState<any>({});
  const [TeamLeaderUid, setTeamLeaderUids] = useState<any>({});
  const [salesUid, setSalesUids] = useState<any>({});
  const [usersList, setUsersList] = useState<any[]>([]);
  const [usersUid, setUsersUids] = useState<any>({});

  useEffect(() => {
    let leadManager: any = [];
    let teamLeader: any = [];
    let sales: any = [];
    let lmuids: { [key: string]: string } = {};
    let tluids: { [key: string]: string } = {};
    let salesuids: { [key: string]: string } = {};
    let lists: any = [];
    let uidList: { [key: string]: string } = {};
    organizationUsers.forEach((item: any, index: number) => {
      if(item.profile !== "Admin" && item.profile !== "Operation Manager"){
        lists.push(
          `${item.user_first_name} ${item.user_last_name} (${item.user_email})  Profile :- (${item.profile})`
        );
        uidList[item.user_email] = item.uid;
      }

      if (item.profile === "Lead Manager") {
        leadManager.push(
          `${item.user_first_name} ${item.user_last_name} (${item.user_email})  Profile :- (${item.profile})`
        );
        lmuids[item.user_email] = item.uid;
      }
      if (item.profile === "Team Lead") {
        teamLeader.push(
          `${item.user_first_name} ${item.user_last_name} (${item.user_email})  Profile :- (${item.profile})`
        );
        tluids[item.user_email] = item.uid;
      }
      if (item.profile === "Sales") {
        sales.push(
          `${item.user_first_name} ${item.user_last_name} (${item.user_email})  Profile :- (${item.profile})`
        );
        salesuids[item.user_email] = item.uid;
      }
    });
    setLeadManagerList(leadManager.sort());
    setTeamLeaderList(teamLeader.sort());
    setSalesList(sales.sort());
    setLeadManagerUids(lmuids);
    setTeamLeaderUids(tluids);
    setSalesUids(salesuids);
    setUsersList(lists.sort());
    setUsersUids(uidList);
  }, [organizationUsers]);

  const onCheck = (event: any, value: string) => {
    if (event.target.checked) {
      let data = [...optionsSelected];
      data.push(value);
      setOptionsSelected(data);
    } else if (!event.target.checked) {
      let data = [...optionsSelected];
      let item = optionsSelected.indexOf(value);
      if (item > -1) {
        data.splice(item, 1);
      }
      setOptionsSelected(data);
    }
  };

  const fetchUserPermission = async () => {
    if (userSelected.value === undefined || userSelected.value === "" || userSelected.value === "Select") {
      if (
        userProfileSelected.value === undefined || userProfileSelected.value === "" || userProfileSelected.value === "Select") {
        return;
      } else {
        if (organizationId) {
          const res: any = await axiosHandler.get(
            url + "/userAuthorization/get",
            {
              params: {
                // organization_id: organizationId,
                profile: userProfileSelected.value,
              },
            }
          );
          if (res.data.data) {
            const keys = Object.entries(res.data.data)
              .filter(([key, value]) => value === true)
              .map(([key]) => key);
            setOptionsSelected(keys);
          }
        }
      }
    } else {
      let userUid;
      const text = userSelected.value;
      const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
      const email = text.match(emailRegex);
      userUid = usersUid[email[0]];
      const res: any = await axiosHandler.get(
        url + "/userAuthorization/get",
        { params: { uid: userUid } }
      );
      if (res.data.data) {
        const keys = Object.entries(res.data.data)
          .filter(([key, value]) => value === true)
          .map(([key]) => key);
        setOptionsSelected(keys);
      }
    }
  };

  useEffect(() => {
    fetchUserPermission();
  }, [userSelected.value, userProfileSelected.value, organizationId]);

  const onSave = async () => {
    let check = false;
    let userUid: any = [];
    if (
      userSelected.value === undefined ||
      userSelected.value === "" ||
      userSelected.value === "Select"
    ) {
      if (
        userProfileSelected.value === undefined ||
        userProfileSelected.value === "" ||
        userProfileSelected.value === "Select"
      ) {
        dispatcher(showSnackbarAction("Please Select User Profile", "error"));
      } else {
        check = true;
        if (userProfileSelected.value === "Lead Manager") {
          leadManagerList.forEach((item: any) => {
            const text = item;
            const emailRegex =
              /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
            const email = text.match(emailRegex);
            userUid.push(leadManagerUid[email[0]]);
          });
        }
        if (userProfileSelected.value === "Team Lead") {
          teamLeaderList.forEach((item: any) => {
            const text = item;
            const emailRegex =
              /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
            const email = text.match(emailRegex);
            userUid.push(TeamLeaderUid[email[0]]);
          });
        }
        if (userProfileSelected.value === "Sales") {
          salesList.forEach((item: any) => {
            const text = item;
            const emailRegex =
              /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
            const email = text.match(emailRegex);
            userUid.push(salesUid[email[0]]);
          });
        }
        userUid.push(userProfileSelected.value);
      }
    } else {
      check = true;
      const text = userSelected.value;
      const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
      const email = text.match(emailRegex);
        userUid.push(usersUid[email[0]]);
    }
    if (check === true) {
      setLoad(true);
      updateUserAuthorization(
        organizationId,
        userUid,
        optionsSelected,
        dispatcher,
        (val) => setLoad(val),
        close,
        authToken
      );
    }
  };
  return (
    <Modal
      isOpen={open}
      className={styles.parent}
      overlayClassName={styles.overlay}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      {load && <Loading />}
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Permissions</p>
      </div>
      <div className={styles.profileContainer}>
        <p className={styles.profile}>Set Permission By:-</p>
        <Dropdown
          option={["Profile", "Specific User"]}
          selectedValue={selectOptionSelected}
          setSelectedValue={(value) => {
            // setUserProfileSelected({label:'Lead Manager',value:'Lead Manager'});
            setUserProfileSelected({label: "Select",
            value: "Select",});
            setUserSelected("Select");
            setSelectOptionSelected(value);
          }}
          />
      </div>
      {selectOptionSelected.value === "Profile" && (
        <div className={styles.profileContainer}>
          <p className={styles.profile}>Select Profile</p>
          <Dropdown
            option={["Lead Manager", "Team Lead", "Sales"]}
            selectedValue={userProfileSelected}
            setSelectedValue={(value) => {
              setUserSelected("Select");
              setUserProfileSelected(value)}
            }
            />
        </div>
      )}
      {selectOptionSelected.value === "Specific User" && (
        <div className={styles.profileContainer}>
          <p className={styles.profile}>Select User</p>
          <Dropdown
            option={usersList}
            selectedValue={userSelected}
            setSelectedValue={(value) => {
              if(value){
                var profileregex = /Profile\s*:-\s*\(([^)]+)\)/;
                var profile = value.value.match(profileregex);
                setUserProfileSelected({label:profile[1],value:profile[1]});
              }
              setUserSelected(value);
            }}
          />
        </div>
      )}
      {userProfileSelected.value === "Lead Manager" && (
        <div className={styles.box}>
          <div className={styles.first}>
            <div className={styles.authHeading}>
              <h6>Contacts</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_transfer_approved");
                }}
                checked={optionsSelected.includes("contact_transfer_approved")}
              />
              <p className={styles.option}>Lead Transfer</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_mass_update_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_mass_update_approved"
                )}
              />
              <p className={styles.option}>Mass Update</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_delete_record_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_delete_record_approved"
                )}
              />
              <p className={styles.option}>Delete Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_import_approved");
                }}
                checked={optionsSelected.includes("contact_import_approved")}
              />
              <p className={styles.option}>Import Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_export_approved");
                }}
                checked={optionsSelected.includes("contact_export_approved")}
              />
              <p className={styles.option}>Export Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_create_approved");
                }}
                checked={optionsSelected.includes("contact_create_approved")}
              />
              <p className={styles.option}>Add Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_update_approved");
                }}
                checked={optionsSelected.includes("contact_update_approved")}
              />
              <p className={styles.option}>Update Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_change_lead_stage_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_change_lead_stage_approved"
                )}
              />
              <p className={styles.option}>Change Lead Stage</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_create_approved"
                )}
              />
              <p className={styles.option}>Add Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_delete_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_delete_approved"
                )}
              />
              <p className={styles.option}>Delete Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_notes_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_notes_create_approved"
                )}
              />
              <p className={styles.option}>Add Notes</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Tasks</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "task_export_approved");
                }}
                checked={optionsSelected.includes("task_export_approved")}
              />
              <p className={styles.option}>Export Tasks</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Projects</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_import_approved");
                }}
                checked={optionsSelected.includes("project_import_approved")}
              />
              <p className={styles.option}>Import Projects</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_export_approved");
                }}
                checked={optionsSelected.includes("project_export_approved")}
              />
              <p className={styles.option}>Export Projects</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_delete_approved");
                }}
                checked={optionsSelected.includes("project_delete_approved")}
              />
              <p className={styles.option}>Delete Projects</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_create_approved");
                }}
                checked={optionsSelected.includes("project_create_approved")}
              />
              <p className={styles.option}>Add Projects</p>
            </div>

            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_update_approved");
                }}
                checked={optionsSelected.includes("project_update_approved")}
              />
              <p className={styles.option}>Update Projects</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_attachments_create_approved");
                }}
                checked={optionsSelected.includes(
                  "project_attachments_create_approved"
                )}
              />
              <p className={styles.option}>Add Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "project_attachments_delete_approved");
                }}
                checked={optionsSelected.includes(
                  "project_attachments_delete_approved"
                )}
              />
              <p className={styles.option}>Delete Attachments</p>
            </div>
          </div>

          <div className={styles.first}>
            <div className={styles.authHeading}>
              <h6>Call Logs</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_call_log_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_call_log_create_approved"
                )}
              />
              <p className={styles.option}>Make Calls</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "calllog_export_approved");
                }}
                checked={optionsSelected.includes("calllog_export_approved")}
              />
              <p className={styles.option}>Export Call Logs</p>
            </div>
            <div className={styles.authHeading}>
              <h6>API Panel</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "api_export_approved");
                }}
                checked={optionsSelected.includes("api_export_approved")}
              />
              <p className={styles.option}>Export API Leads</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Lead Distribution</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "lead_distribution_create_approved");
                }}
                checked={optionsSelected.includes(
                  "lead_distribution_create_approved"
                )}
              />
              <p className={styles.option}>Create Distribution Logic</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "lead_distribution_update_approved");
                }}
                checked={optionsSelected.includes(
                  "lead_distribution_update_approved"
                )}
              />
              <p className={styles.option}>Update Distribution Logic</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "lead_distribution_delete_approved");
                }}
                checked={optionsSelected.includes(
                  "lead_distribution_delete_approved"
                )}
              />
              <p className={styles.option}>Delete Distribution Logic</p>
            </div>
            <div className={styles.authHeading}>
              <h6>FAQ</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "faq_create_approved");
                }}
                checked={optionsSelected.includes("faq_create_approved")}
              />
              <p className={styles.option}>Add FAQ</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "faq_update_approved");
                }}
                checked={optionsSelected.includes("faq_update_approved")}
              />
              <p className={styles.option}>Update FAQ</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "faq_delete_approved");
                }}
                checked={optionsSelected.includes("faq_delete_approved")}
              />
              <p className={styles.option}>Delete FAQ</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Subscription Panel</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "show_subscription_panel");
                }}
                checked={optionsSelected.includes("show_subscription_panel")}
              />
              <p className={styles.option}>Show Subscription Details</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Resource Panel</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "resource_create_approved");
                }}
                checked={optionsSelected.includes("resource_create_approved")}
              />
              <p className={styles.option}>Add Resources</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "resource_update_approved");
                }}
                checked={optionsSelected.includes("resource_update_approved")}
              />
              <p className={styles.option}>Update Resources</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "resource_delete_approved");
                }}
                checked={optionsSelected.includes("resource_delete_approved")}
              />
              <p className={styles.option}>Delete Resources</p>
            </div>
          </div>
        </div>
      )}
      {userProfileSelected.value === "Team Lead" && (
        <div className={styles.box}>
          <div className={styles.first}>
            <div className={styles.authHeading}>
              <h6>Contacts</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_transfer_approved");
                }}
                checked={optionsSelected.includes("contact_transfer_approved")}
              />
              <p className={styles.option}>Lead Transfer</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_mass_update_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_mass_update_approved"
                )}
              />
              <p className={styles.option}>Mass Update</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_import_approved");
                }}
                checked={optionsSelected.includes("contact_import_approved")}
              />
              <p className={styles.option}>Import Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_create_approved");
                }}
                checked={optionsSelected.includes("contact_create_approved")}
              />
              <p className={styles.option}>Add Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_update_approved");
                }}
                checked={optionsSelected.includes("contact_update_approved")}
              />
              <p className={styles.option}>Update Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_change_lead_stage_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_change_lead_stage_approved"
                )}
              />
              <p className={styles.option}>Change Lead Stage</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_create_approved"
                )}
              />
              <p className={styles.option}>Add Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_delete_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_delete_approved"
                )}
              />
              <p className={styles.option}>Delete Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_notes_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_notes_create_approved"
                )}
              />
              <p className={styles.option}>Add Notes</p>
            </div>
          </div>

          <div className={styles.first}>
            <div className={styles.authHeading}>
              <h6>Call Logs</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_call_log_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_call_log_create_approved"
                )}
              />
              <p className={styles.option}>Make Calls</p>
            </div>
          </div>
        </div>
      )}
      {userProfileSelected.value === "Sales" && (
        <div className={styles.box}>
          <div className={styles.first}>
            <div className={styles.authHeading}>
              <h6>Contacts</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_create_approved");
                }}
                checked={optionsSelected.includes("contact_create_approved")}
              />
              <p className={styles.option}>Add Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_update_approved");
                }}
                checked={optionsSelected.includes("contact_update_approved")}
              />
              <p className={styles.option}>Update Contacts</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_change_lead_stage_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_change_lead_stage_approved"
                )}
              />
              <p className={styles.option}>Change Lead Stage</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_create_approved"
                )}
              />
              <p className={styles.option}>Add Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_attachments_delete_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_attachments_delete_approved"
                )}
              />
              <p className={styles.option}>Delete Attachments</p>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_notes_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_notes_create_approved"
                )}
              />
              <p className={styles.option}>Add Notes</p>
            </div>
            <div className={styles.authHeading}>
              <h6>Call Logs</h6>
            </div>
            <div className={styles.detail}>
              <input
                type="checkbox"
                onChange={(e) => {
                  onCheck(e, "contact_call_log_create_approved");
                }}
                checked={optionsSelected.includes(
                  "contact_call_log_create_approved"
                )}
              />
              <p className={styles.option}>Make Calls</p>
            </div>
          </div>
        </div>
      )}
      <div className={styles.buttonView}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={() => onSave()}>
          Save
        </button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    user: state.user.data,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(AuthorizationViewModal);
